module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "fonts/open-sans-semi-bold.woff2";